import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnotherWayLoginComponent } from '@pg-app/auth/components/another-way-login/another-way-login.component';
import { LoginErrorPhoneComponent } from '@pg-app/auth/components/login-error-phone/login-error-phonecomponent';
import { LoginLayoutComponent } from '@pg-app/auth/components/login-layout/login-layout.component';
import { ReturnLoginLayoutComponent } from '@pg-app/auth/components/return-login-layout/return-login-layout.component';
import { ChangePasswordComponent } from '@pg-app/auth/containers/login/change-password/change-password.component';
import { ChangePinComponent } from '@pg-app/auth/containers/login/change-pin/change-pin.component';
import { LoginStep2Component } from '@pg-app/auth/containers/login/login-step2/login-step2.component';
import { LoginStep3Component } from '@pg-app/auth/containers/login/login-step3/login-step3.component';
import { LoginComponent } from '@pg-app/auth/containers/login/login/login.component';
import { ReactivateAccountComponent } from '@pg-app/auth/containers/login/reactivate-account/reactivate-account.component';
import { ReactivateSendCodeComponent } from '@pg-app/auth/containers/login/reactivate-send-code/reactivate-send-code.component';
import { ResetPasswordSendCodeComponent } from '@pg-app/auth/containers/login/reset-password-send-code/reset-password-send-code.component';
import { ResetPasswordComponent } from '@pg-app/auth/containers/login/reset-password/reset-password.component';
import { ResetPinSendCodeComponent } from '@pg-app/auth/containers/login/reset-pin-send-code/reset-pin-send-code.component';
import { ResetPinComponent } from '@pg-app/auth/containers/login/reset-pin/reset-pin.component';
import { AddPhoneNumberComponent } from '@pg-app/auth/containers/register/add-phone-number/add-phone-number.component';
import { RegisterComponent } from '@pg-app/auth/containers/register/register/register.component';
import { VerifyEmailComponent } from '@pg-app/auth/containers/register/verify-email/verify-email.component';
import { VerifyPasscodeComponent } from '@pg-app/auth/containers/register/verify-passcode/verify-passcode.component';
import { LoginStep2Guard } from '@pg-app/auth/services/login-step-2.guard';
import { LoginStep3Guard } from '@pg-app/auth/services/login-step-3.guard';
import { ResetPasswordOrPinCodeGuard } from '@pg-app/auth/services/reset-password-pincode.guard';
import { AlternativeReceiveCodeComponent } from '@pg-app/auth/components/alternative-receive-code/alternative-receive-code.component';
import { RegisterCorporateComponent } from '@pg-app/auth/containers/register/register-corporate/register-corporate.component';
import { ProfileSwitchingComponent } from './containers/login/profile-switching/profile-switching.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: LoginComponent
      },
      {
        path: 'step-2',
        component: LoginStep2Component,
        canActivate: [LoginStep2Guard]
      },
      {
        path: 'step-3',
        component: LoginStep3Component,
        canActivate: [LoginStep3Guard]
      },
      {
        path: 'reactivate-account',
        component: ReactivateAccountComponent
      },
      {
        path: 'return-login',
        component: ReturnLoginLayoutComponent
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent
      },
      {
        path: 'another-way-login',
        component: AnotherWayLoginComponent
      },
      {
        path: 'reactivate-send-code',
        component: ReactivateSendCodeComponent
      },
      {
        path: 'reset-password-send-code',
        component: ResetPasswordSendCodeComponent
      },
      {
        path: 'change-password',
        canActivate: [ResetPasswordOrPinCodeGuard],
        component: ChangePasswordComponent
      },
      {
        path: 'reset-memorable-number',
        component: ResetPinComponent
      },
      {
        path: 'reset-pin-send-code',
        component: ResetPinSendCodeComponent
      },
      {
        path: 'change-memorable-number',
        canActivate: [ResetPasswordOrPinCodeGuard],
        component: ChangePinComponent
      },
      {
        path: 'login-error-phone',
        component: LoginErrorPhoneComponent
      },
      {
        path: 'profile-switching',
        component: ProfileSwitchingComponent
      }
    ]
  },
  {
    path: 'register',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: RegisterComponent
      },
      {
        path: 'new-corporate',
        component: RegisterCorporateComponent
      },
      {
        path: 'verify-email',
        component: VerifyEmailComponent
      },
      {
        path: 'add-phone-number',
        component: AddPhoneNumberComponent
      },
      {
        path: 'verify-passcode',
        component: VerifyPasscodeComponent
      },
      {
        path: 'alternative-receive-code',
        component: AlternativeReceiveCodeComponent
      }
    ]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
